import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import { forwardRef, HTMLAttributes } from 'react'

import { Heading, Text } from '@/shared/ui'

import cl from './plastic-card-promotion.module.scss'

const variants = {
	nbclub: {
		image:
			'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/shared/ui-elements/plastic-card-promotion/nb-club-plastic-card.jpg',
		title: 'Программа лояльности NBclub',
		text: <>Присоединяйтесь к&nbsp;NBclub — возвращайте до&nbsp;3%, экономьте до&nbsp;99%</>,
		alt: 'Экземпляр пластиковой карты программы лояльности NBclub',
		content: (
			<Link prefetch={false} href="/services/iport-card/" className={cl.card__buttonLink}>
				Подробнее
			</Link>
		)
	},
	'iport-plus-service': {
		image:
			'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/shared/ui-elements/plastic-card-promotion/iport-plus-service-card.jpg',
		title: 'iPort+ Service',
		text: <>Получите полную поддержку, гарантии&nbsp;и выгодные предложения в сервисных центрах iPort</>,
		alt: 'Экземпляр пластиковой карты iPort+ Service',
		content: (
			<Link prefetch={false} href="/service/iport-card/" className={cl.card__buttonLink}>
				Подробнее
			</Link>
		)
	},
	'for-business': {
		image:
			'https://storage.yandexcloud.net/tf-bitrix-upload/iport/public/assets/shared/ui-elements/plastic-card-promotion/for-business-card.jpg',
		title: 'Сервисное обслуживание для бизнеса',
		text: <>Ремонт корпоративной техники Apple&nbsp;— платно или&nbsp;по&nbsp;действующей гарантии</>,
		alt: 'Экземпляр пластиковой карты программы лояльности NBclub',
		content: (
			<Link prefetch={false} href="/service/for-business/" className={cl.card__buttonLink}>
				Подробнее
			</Link>
		)
	}
} as const

interface PlasticCardPromotionProps extends HTMLAttributes<HTMLDivElement> {
	variant?: 'nbclub' | 'iport-plus-service' | 'for-business'
}

export const PlasticCardPromotion = forwardRef<HTMLDivElement, PlasticCardPromotionProps>((props, ref) => {
	const { variant = 'iport-plus-service', className, ...rest } = props

	const data = variants[variant]

	return (
		<div ref={ref} className={clsx(cl.card, className)} {...rest}>
			<div className={cl.card__content}>
				<Heading preset="h4" className={cl.card__title}>
					{data.title}
				</Heading>
				<Text className={cl.card__text}>{data.text}</Text>
				{data.content}
			</div>
			{data.image && (
				<div className={cl.card__background}>
					<Image src={data.image} width={170} height={296} quality={100} loading="lazy" aria-hidden alt={data.alt} />
				</div>
			)}
		</div>
	)
})
